export default __webpack_public_path__ + "static/media/sflex-logo-white-1.8c500db0.png";